import PaymentMethodsInput from '../../components/pages/payment_methods/payment-methods-input.vue'
export default {
  components: { PaymentMethodsInput }
}
